import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import config from 'config/services/firebase';

class Firebase {
  constructor() {
    firebase.initializeApp(config);
    this.firebase = firebase;

    this.auth = firebase.auth();
    this.db = firebase.database();

    this.user = new Promise(resolve => {
      this.auth.onAuthStateChanged(async authUser => {
        if (!authUser) return null;
        const user = await this.db.ref(`users/${authUser.uid}`);

        resolve(user);
      });
    });

    this.userData = () => new Promise(async resolve => {
      const userRef = await this.user;
      userRef.once('value', snapshot => resolve(snapshot.val()));
    });
  }

  userBindRedux = (user, saveUser) => {
    user.on('value', snapshot => saveUser(snapshot.val()));
  }

  companies = () => this.db.ref('companies');
  company = companyId => this.db.ref(`companies/${companyId}`);
  companyBindRedux = (companyId, saveCompany) => {
    this.company(companyId).on('value', snapshot => saveCompany(snapshot.val()));
  }
  companyByName = name => this.companies()
    .orderByChild('name')
    .equalTo(name)
    .limitToFirst(1);
    
  companyData = companyId => new Promise(async resolve => {
    const companyRef = await this.company(companyId);
    companyRef.once('value', snapshot => resolve(snapshot.val()));
  });

  conversations = ({ companyId }) => this.db.ref('conversations')
    .orderByChild('companyId')
    .equalTo(companyId)
    .limitToLast(100);
  conversation = conversationId => this.db.ref(`conversations/${conversationId}`);
}

export default Firebase;
